import * as React from 'reactn';
import {
    ArrayUtil, ComponentFactory,
    dialog,
    IBaseDialogProps,
    SelectItem,
} from "oca-lib-web";
import AnalyticsEngine from "../data/AnalyticsEngine";
import GraphUtil from "../util/GraphUtil";
import Styles from "../style/Styles";
import CacheSettings from 'src/util/CacheSettings';
import DataMappingUtil from "../util/DataMappingUtil";

interface IState {
    componentFactory:ComponentFactory,
    graphSettings?:GraphSettings,
    graphSelection?:GraphSelection,
    selectionNameOptions:Array<SelectItem>,
    selectionValueOptions:Array<SelectItem>,
    dataMappings:Array<DataMapping>
    //dataset:Array<any>
}

class SelectionDialog extends React.Component<IBaseDialogProps, IState> {

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        //componentFactory.addDefaultBinding(null, null, this.props.param.graphSettings);
        componentFactory.addDefaultBinding(null, null, null);
        componentFactory.setHandleUpdateCallback((value:any, key:string) => {
            if (key == "selectionName") {
                this.updateGraphSelectionItems(value);
                this.forceUpdate();
            } else if (key == "isCustom") {
                this.forceUpdate();
            }
        });

        this.state = {
            componentFactory:componentFactory,
            graphSettings: props.param ? props.param.graphSettings : {},
            graphSelection: props.param && props.param.graphSelection ? props.param.graphSelection : {},
            selectionNameOptions: [],
            selectionValueOptions: [],
            dataMappings:[]
            //dataset: []
        };
        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    async componentDidMount() {
        var projectId = CacheSettings.getCurrentProject();
        let dataMappings = await this.global.dataManager.get("getDataMappings", projectId);
        let xAxisOptions = GraphUtil.getXAxisOptions(this.state.graphSettings);
        ArrayUtil.sort(xAxisOptions);
        let selectionNameOptions = [];
        for (let xAxisOption of xAxisOptions) {
            selectionNameOptions.push(SelectItem.create(xAxisOption, DataMappingUtil.replaceData(xAxisOption, dataMappings)));
        }
        this.setState({selectionNameOptions: selectionNameOptions, dataMappings:dataMappings});
        if (this.state.graphSelection.selectionName) {
            this.updateGraphSelectionItems(this.state.graphSelection.selectionName);
        }
    }

    async handleSave(callback:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        console.log(componentBinding.item);

        callback(componentBinding.item);
    }

    updateGraphSelectionItems(selectionName:string) {
        let uniqueItems = AnalyticsEngine.getUniqueDataValues(this.state.graphSettings, selectionName);
        //ArrayUtil.sort(uniqueItems);
        let selectionValueOptions = [];
        for (let uniqueItem of uniqueItems) {
            if (uniqueItem && uniqueItem != "") {
                selectionValueOptions.push(SelectItem.create(uniqueItem, DataMappingUtil.replaceData(uniqueItem, this.state.dataMappings)));
            }
        }
        ArrayUtil.sort(selectionValueOptions, "label");
        this.setState({selectionValueOptions: selectionValueOptions});
    }

    hasMultipleValues(key:string): boolean {
        return key == "selectionValues";
    }

    // Filter selection dialog
    public render() {
        let cf = this.state.componentFactory;
        let isCustom = cf.getDefaultBinding().getProperty("isCustom");

        return (
            cf.renderBox([
                cf.renderBoxPadded(cf.renderSelectField("selectionName", "Selection Name", this.state.selectionNameOptions)),
                    cf.renderBoxPadded(isCustom ?  cf.renderTextField("selectionValuesCustom", "Selection Values") :
                        cf.renderSelectField("selectionValues", "Selection Values", this.state.selectionValueOptions, null, null, {multiple:true})),
                cf.renderBoxPadded(cf.renderSwitchField("isCustom", "Custom"))
            ])
        )
    }
}

export default dialog(SelectionDialog)